import { useContext } from 'react';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import { SchedulerContext } from '../../SchedulerContext';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  daySize: {
    '& > :first-of-type': {
      '& > div:first-of-type': {
        [theme.breakpoints.down('md')]: {
          fontSize: theme.typography.pxToRem(15),
        },
      },
    },
  },
  redDay: {
    '& .Cell-dayOfMonth': { color: 'red' },
    '& .Cell-dayOfWeek': { color: 'red' },
  },
}));

export const DayWeekViewDayScaleCellCustom = (
  props: WeekView.DayScaleCellProps
) => {
  const { classes, cx } = useStyles();
  const schedulerContext = useContext(SchedulerContext);
  const cellDay = props.startDate.toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  const redDay = Boolean(
    schedulerContext.redDays.find(
      day =>
        day.toLocaleDateString('sv-SE', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }) === cellDay
    )
  );
  return (
    <WeekView.DayScaleCell
      {...props}
      className={cx(classes.daySize, {
        [classes.redDay]: redDay,
      })}
    ></WeekView.DayScaleCell>
  );
};
